
import { apiClient } from '../../client'


export interface FirstBlockData {
    curr_month_avl_pct: number
    no_of_skus: number
    no_of_stores: number
    /** @deprecated kept optional for older payload shapes */
    last_month_total?: number
    last_month_avl?: number
    curr_month_total?: number
    curr_month_avl?: number
    variance_pct?: number
}

export interface DCBoxData {
    last_month_dc_total: number
    last_month_dc_avl: number
    curr_month_dc_total: number
    curr_month_dc_avl: number
    variance_pct: number
    curr_month_dc_avl_pct: number;
}

export interface DSDBoxData {
    last_month_dsd_total: number
    last_month_dsd_avl: number
    curr_month_dsd_total: number
    curr_month_dsd_avl: number
    curr_month_dsd_avl_pct: number;
    variance_pct: number;
}

export interface CategoryBoxData {
    category: string
    curr_month_cat_avl_pct: number
    no_of_skus: number
    no_of_stores: number
}

export interface SubcategoryBoxData {
    sub_category: string
    curr_month_subcat_avl_pct: number
    no_of_skus: number
    no_of_stores: number
}

export interface BrandBoxData {
    brand: string
    curr_month_brand_avl_pct: number
    no_of_skus: number
    no_of_stores: number
}

export interface RegionBoxData {
    region: string
    curr_month_region_avl_pct: number
    no_of_skus: number
    no_of_stores: number
}

export interface ChainBoxData {
    chain: string
    curr_month_chain_avl_pct: number
    no_of_skus: number
    no_of_stores: number
}

export interface ChannelBoxData {
    channel: string
    curr_month_channel_avl_pct: number
    no_of_skus: number
    no_of_stores: number
}


export interface OsaByDateData {
    report_date: string
    osa_percentage: number
}

export interface PrincipalsTableData {
    category: string
    sub_category: string
    brand: string
    sku: string
    curr_month_sku_avl_pct: number
    no_of_skus: number
    no_of_stores: number
}
export interface StoreHeatMapData {
    store_name: string
    g_code: string
    lat: number
    lng: number
    store_osa: number
    no_of_skus: number
    no_of_stores: number
}




function appendFilterParams(params: URLSearchParams, filters: any): void {
    if (!filters) return;

    const append = (key: string, value: any) => {
        if (Array.isArray(value) && value.length) {
            params.append(key, value.join(','));
        } else if (typeof value === 'string' && value.length) {
            params.append(key, value);
        } else if (value != null) {
            params.append(key, value.toString());
        }
    };

    append('client_ids', filters.client_ids);
    append('client_id', filters.client_id);

    append('bu_ids', filters.bu_ids);
    append('bu_id', filters.bu_id);

    append('department_ids', filters.department_ids);
    append('department_id', filters.department_id);

    append('category_ids', filters.category_ids);
    append('category_id', filters.category_id);

    append('subcategory_ids', filters.subcategory_ids);
    append('subcategory_id', filters.subcategory_id);

    append('brand_ids', filters.brand_ids);
    append('brand_id', filters.brand_id);

    append('sku_ids', filters.sku_ids);
    append('sku_id', filters.sku_id);

    append('region_ids', filters.region_ids);
    append('region_id', filters.region_id);

    append('city_ids', filters.city_ids);
    append('city_id', filters.city_id);

    append('chain_ids', filters.chain_ids);
    append('chain_id', filters.chain_id);

    append('store_ids', filters.store_ids);
    append('store_id', filters.store_id);

    append('start_date', filters.start_date);
    append('end_date', filters.end_date);

    append('ref_ids', filters.ref_ids);
    append('ref_id', filters.ref_id);

    append('channel_ids', filters.channel_ids);
    append('channel_id', filters.channel_id);
}


class AvailabilityRepository {


    async firstBlock(filters?: any): Promise<FirstBlockData> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        // Only add '?' if there are parameters
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/first-box${queryString ? '?' + queryString : ''}`;

        return apiClient.get(url)
    }

    async getDCBox(filters?: any): Promise<DCBoxData> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        // Only add '?' if there are parameters
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/dc-box${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url)
    }

    async getDSDBox(filters?: any): Promise<DSDBoxData> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        // Only add '?' if there are parameters
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/dsd-box${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url);
    }

    async getCategoryBox(filters?: any): Promise<CategoryBoxData[]> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        // Only add '?' if there are parameters
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/category-box${queryString ? '?' + queryString : ''}`;

        return apiClient.get(url)
    }


    async getSubcategoryBox(filters?: any): Promise<SubcategoryBoxData[]> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        // Only add '?' if there are parameters
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/subcategory-box${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url);
    }

    async getBrandBox(filters?: any): Promise<BrandBoxData[]> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        // Only add '?' if there are parameters
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/brand-box${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url)
    }

    async getRegionBox(filters?: any): Promise<RegionBoxData[]> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/region-box${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url);
    }

    async getChainBox(filters?: any): Promise<ChainBoxData[]> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/chain-box${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url);
    }

    async getChannelBox(filters?: any): Promise<ChannelBoxData[]> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/channel-box${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url);
    }

    async getStoreHeatMap(filters?: any): Promise<StoreHeatMapData[]> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        // Only add '?' if there are parameters
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/store-heat-map${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url)
    }

    async getPrincipalsTable(filters?: any): Promise<PrincipalsTableData[]> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        // Only add '?' if there are parameters
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/principals-table${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url);
    }

    async getOsaByDate(filters?: any): Promise<OsaByDateData[]> {
        const params = new URLSearchParams();
        appendFilterParams(params, filters);
        // Only add '?' if there are parameters
        const queryString = params.toString();
        const url = `/business-kpi-dashboards/osa-by-date${queryString ? '?' + queryString : ''}`;
        return apiClient.get(url)
    }
}

export const availabilityRepository = new AvailabilityRepository()

